import script from "./searchInputSyoten.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchInputSyoten.vue?vue&type=script&setup=true&lang=ts"

import "./searchInputSyoten.vue?vue&type=style&index=0&id=2f802d98&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f802d98"]])

export default __exports__